import { render, staticRenderFns } from "./DataRolePermissionsIndex.vue?vue&type=template&id=935353cc&scoped=true&"
import script from "./DataRolePermissionsIndex.vue?vue&type=script&lang=js&"
export * from "./DataRolePermissionsIndex.vue?vue&type=script&lang=js&"
import style0 from "./DataRolePermissionsIndex.vue?vue&type=style&index=0&id=935353cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935353cc",
  null
  
)

export default component.exports